<template>
  <div class='col-12 col-lg-8 g c'>
    <div class="card card-body" style="border-radius: 20px">
        <div class="form-group">
          <label for="">الرسالة</label>
          <textarea class="form-control" v-model="message" rows="5" placeholder="الرسالة هنا..."></textarea>
        </div>
        <div class="col-12 text-center">
            <button class="btn btn-primary" style="border-radius: 50px" @click="add()">
                <i class="fa fa-plus"></i>
                اضافة رسالة جديدة
            </button>
        </div>
        <hr>
        <div class="col-12 table-responsive">
            <table class="table table-hover table-bordered table-sm">
                <thead>
                    <th>
                        الرسالة
                    </th>
                    <th>
                        حذف
                    </th>
                </thead>
                <tbody>
                    <tr v-for="t in templates" :key="t._id">
                        <td>
                            {{ t.message }}
                        </td>
                        <td>
                            <button class="btn btn-outline-danger btn-sm" @click="remove(t._id)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            templates: [],
            message: "",
            user: JSON.parse(localStorage.getItem("user")),
        }
    },
    created(){
        this.getTemplates()
    },
    methods: {
        getTemplates(){
            var g = this;
            $.post(api + '/user/general/templates/list', {
                jwt: this.user.jwt,
            }).then(function(r){
                g.templates = r.response
            }).fail(function(){
                g.error = "حدث مشكلة في الاتصال"
            })
        },
        add(){
            if(!this.message || this.message == ""){
                alert("برجاء كتابة الرسالة", 200)
            }else{
                var g = this;
                $.post(api + '/user/general/templates/add', {
                    jwt: this.user.jwt,
                    message: g.message
                }).then(function(r){
                    g.getTemplates()
                    g.message = "";
                }).fail(function(){
                    g.error = "حدث مشكلة في الاتصال"
                })
            }
        },
        remove(i){
            if(confirm('متأكد من حذف الرسالة؟')){
                var g = this;
                $.post(api + '/user/general/templates/delete', {
                    jwt: this.user.jwt,
                    id: i
                }).then(function(r){
                    g.getTemplates()
                    g.message = "";
                }).fail(function(){
                    g.error = "حدث مشكلة في الاتصال"
                })
            }
        }
    }
}
</script>

<style>

</style>